export enum CourseType {
  TRAINING = 'training',
  COURSE = 'course'
}
